import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isNumber } from '@antv/util';
import { compose } from './compose';
var createInterpolatorRound = function createInterpolatorRound(interpolator) {
  return function (t) {
    // If result is not number, it can't be rounded.
    var res = interpolator(t);
    return isNumber(res) ? Math.round(res) : res;
  };
};
export function interpolatize(rangeOf, normalizeDomain) {
  return function (Scale) {
    Scale.prototype.rescale = function () {
      this.initRange();
      this.nice();
      var _this$chooseTransform = this.chooseTransforms(),
        _this$chooseTransform2 = _slicedToArray(_this$chooseTransform, 1),
        transform = _this$chooseTransform2[0];
      this.composeOutput(transform, this.chooseClamp(transform));
    };
    Scale.prototype.initRange = function () {
      var interpolator = this.options.interpolator;
      this.options.range = rangeOf(interpolator);
    };
    Scale.prototype.composeOutput = function (transform, clamp) {
      var _this$getOptions = this.getOptions(),
        domain = _this$getOptions.domain,
        interpolator = _this$getOptions.interpolator,
        round = _this$getOptions.round;
      var normalize = normalizeDomain(domain.map(transform));
      var interpolate = round ? createInterpolatorRound(interpolator) : interpolator;
      this.output = compose(interpolate, normalize, clamp, transform);
    };
    Scale.prototype.invert = undefined;
  };
}